export default __webpack_public_path__ + "static/media/general_notify_icon.390574aa.svg";